import { CompanyLookupDetailsModel } from './../models/dms/addressLookup.model';
import { CompanyLookupModel } from 'app/models/dms/addressLookup.model';
import { AddressLookupModel } from 'app/models/dms/addressLookup.model';
import { Constants } from 'app/utility/constants';


import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressLookupService 
{

  labelAttribute = 'formatted';
  formValueAttribute = '';

  private countries: any[] = [];

  constructor(private httpClient: HttpClient)
  {

  }

  getResults(keyword: string):Observable<AddressLookupModel[]>
  {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', keyword);
    return this.httpClient.get<AddressLookupModel[]>(Constants.ApiUrl + 'Addresses', { params: httpParams });
  }

  getCompanyResults(keyword: string):Observable<CompanyLookupModel[]>
  {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('query', keyword);
    return this.httpClient.get<CompanyLookupModel[]>(Constants.ApiUrl + 'Addresses/company', { params: httpParams });
  }

  getCompanyDetails(nzbn: string):Observable<CompanyLookupDetailsModel>
  {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('nzbn', nzbn);
    return this.httpClient.get<CompanyLookupDetailsModel>(Constants.ApiUrl + 'Addresses/company/'+nzbn, { params: httpParams });
  }
}